import Paper from "@mui/material/Paper";
import styled from "styled-components";

export const GobShell = styled.div`
  height: calc(100vh - (var(--navbar-height) + var(--footer-height)));
  width: 100%;
  display: grid;
  grid-template-columns: ${(p) => (p.$leftOpen ? "200px" : "0px")} minmax(0, 1fr)
    ${(p) => (p.$rightOpen ? "280px" : "0px")};
  background: #f4f7fe;
  overflow: hidden;
  transition: grid-template-columns 200ms ease;
`;

export const LeftPanel = styled.div`
  grid-column: 1;
  background: #fff;
  border-right: 1px solid #e9edf7;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 10px 0px 30px rgba(0, 0, 0, 0.02);
  font-family: var(--font-body);
`;

export const MainPanel = styled.div`
  grid-column: 2;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-family: var(--font-body);
`;

export const MainHeader = styled.div`
  height: ${(p) => (p.$hidden ? "0px" : "44px")};
  padding: ${(p) => (p.$hidden ? "0" : "6px 16px")};
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border-bottom: ${(p) => (p.$hidden ? "none" : "1px solid rgba(15, 23, 42, 0.06)")};
  overflow: hidden;
  transition: height 200ms ease;
`;

export const MainHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
`;

export const MainHeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const MainScroll = styled.div`
  flex: 1;
  overflow: auto;
  background: #f4f7fe;
  padding: 12px 16px;
`;

export const ContentInner = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const RightPanel = styled.div`
  grid-column: 3;
  background: #fff;
  border-left: 1px solid #e9edf7;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: -10px 0px 30px rgba(0, 0, 0, 0.02);
  font-family: var(--font-body);
`;

export const CardPaper = styled(Paper)`
  border-radius: 12px !important;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
  font-family: var(--font-body);
`;

export const BarTitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-width: 0;
  padding: 8px 0 12px;
  border-bottom: 1px solid #eef2f7;
`;

export const BarRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 0;
  border-bottom: 1px solid #f1f5f9;
  min-width: 0;
  padding-left: ${(p) => `${(Number(p.$nivel) || 0) * 16}px`};
  cursor: ${(p) => (p.$clickable ? "pointer" : "default")};
  &:hover {
    background: ${(p) => (p.$clickable ? "#f7fafc" : "transparent")};
  }
`;

export const ChevronCell = styled.span`
  width: 16px;
  flex-shrink: 0;
  text-align: center;
  color: #a0aec0;
  font-weight: 700;
  font-size: 12px;
  user-select: none;
  visibility: ${(p) => (p.$visible ? "visible" : "hidden")};
`;

export const BarLabel = styled.div`
  font-size: 12px;
  font-weight: 550;
  color: #0f172a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  flex: 0 0 auto;
  width: ${(p) => p.$w || "230px"};
  font-family: var(--font-body);
`;

export const BarTrack = styled.div`
  flex: 1;
  height: 12px;
  background: #eef2f7;
  border-radius: 99px;
  overflow: hidden;
  display: flex;
  align-items: center;
  min-width: 0;
`;

export const BarSegment = styled.div`
  height: 12px;
  background: ${(p) => p.$bg || "#1054ad"};
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 6px;
  font-size: 10px;
  font-weight: 750;
  color: #0f172a;
  white-space: nowrap;
  overflow: visible;
  min-width: 0;
  font-family: var(--font-body);
  transition: width 300ms ease;
`;

export const BarValor = styled.div`
  width: 130px;
  flex-shrink: 0;
  text-align: right;
  font-size: 11px;
  color: #475569;
  font-weight: 650;
  font-family: var(--font-body);
`;

export const LegendList = styled.div`
  width: 180px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  font-family: var(--font-body);
`;

export const LegendDot = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 3px;
  background: ${(p) => p.$color || "#94a3b8"};
  flex: 0 0 auto;
`;

export const HeatWrap = styled.div`
  overflow-x: auto;
  font-family: var(--font-body);
`;

export const HeatTable = styled.table`
  width: 100%;
  min-width: 600px;
  border-collapse: separate;
  border-spacing: 0;
  font-family: var(--font-body);
`;

export const HeatTh = styled.th`
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  padding: 4px 6px;
  font-size: 9.5px;
  color: #334155;
  font-weight: 700;
  text-align: ${(p) => p.$align || "center"};
  position: sticky;
  top: 0;
  z-index: 1;
  white-space: ${(p) => (p.$firstCol ? "nowrap" : "normal")};
  font-family: var(--font-body);
  ${(p) => (p.$firstCol ? "position: sticky; left: 0; z-index: 2;" : "")}
`;

export const HeatTd = styled.td`
  border: 1px solid #e2e8f0;
  padding: 3px 6px;
  font-size: 10px;
  text-align: ${(p) => p.$align || "center"};
  background: ${(p) => p.$bg || "#ffffff"};
  color: ${(p) => p.$color || "#0f172a"};
  font-weight: ${(p) => (p.$bold ? 700 : 500)};
  white-space: ${(p) => (p.$wrap ? "normal" : "nowrap")};
  line-height: 1.2;
  vertical-align: middle;
  font-family: var(--font-body);
  ${(p) =>
    p.$firstCol
      ? "position: sticky; left: 0; z-index: 1; background: " +
        (p.$bg || "#f8fafc") +
        ";"
      : ""}
`;
